/**
 * Route for `igaming-chargeback-refund-events`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingChargebackRefundEventsPage } from "../features/igaming-chargeback-refund-events/IgamingChargebackRefundEventsPage";

export const igamingChargebackRefundEventsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-chargeback-refund-events",
	component: IgamingChargebackRefundEventsPage,
});

export default igamingChargebackRefundEventsRoute;
